import { useTheme } from '@mui/styles';

export const useBorderColor = (isSelected: boolean, isLocked?: boolean) => {
  const theme = useTheme();

  if (isSelected) return theme.palette.secondary.dark;

  if (isLocked) return theme.palette.grey[100];

  return theme.palette.grey[200];
};
